<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      entity-name="Pfand"
      :model="pfandModel"
      :use-default-action="false"
      :uuse-custom-action="true"
      icon="mdi-label"
      style="width: 100%"
    >
      <template #footer>
        <v-btn
          class="green"
          @click="refresh"
        >
          {{ $t('refresh') }}
        </v-btn>
      </template>
      <template #item.action="{ item }">
        <v-btn
          class="mr-2"
          small
          @click="handleDialog(item)"
        >
          {{ $t('edit') }}
        </v-btn>
      </template>
    </ik-data-table>

    <v-dialog
      v-model="showEditPfand"
      width="40vw"
    >
      <v-card class="px-4">
        <v-card-title>
          {{ $t('pfandName') }}
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="selectedPfand"
            :items="pfandList"
            class="mb-4"
            item-text="pfandName"
            item-value="id"
            return-object
            style="size: 18px"
          />
        </v-card-text>

        <v-card-actions class="pb-4">
          <v-btn
            color="blue"
            @click="handleRemovePfand"
          >
            {{ $t('cancle_deposit') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="red"
            @click="showEditPfand= false"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="green"
            @click="editPfand"
          >
            {{ $t('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Pfand, { getPfandList } from '@/model/dataLayer/api/dish/Pfand.js'
import hillo from 'hillo'

export default {
  name: 'PfandSetting',
  components: {
    IkDataTable
  },
  data () {
    return {
      pfandModel: Pfand,
      selectedPfand: null,
      showEditPfand: false,
      pfandList: null,
      editDish: null
    }
  },
  async mounted () {
    this.pfandList = await getPfandList()
    this.selectedPfand = this.pfandList[0]
  },
  methods: {

    handleDialog (item) {
      this.showEditPfand = true
      this.editDish = item
    },

    async editPfand () {
      if (this.editDish.pfandId && this.editDish.pfandId.toString() === this.selectedPfand.id.toString()) {
        this.editDish = null
        this.showEditPfand = false
        return null
      } else {
        await hillo.postWithUploadFile(
          'Dishes.php?op=flipManyCombination',
          {
            dishIdComboDishIds: JSON.stringify([
              {
                dishId: this.editDish.id,
                comboDIshId: parseInt(this.editDish.pfandId)
              },
              {
                dishId: this.editDish.id,
                comboDIshId: parseInt(this.selectedPfand.id)
              }
            ])
          },
          { showLoading: true }
        )
      }

      this.editDish = null
      this.showEditPfand = false
      this.pfandModel.reload()
      // location.reload()
    },

    async handleRemovePfand () {
      await hillo.postWithUploadFile(
        'Dishes.php?op=flipManyCombination',
        {
          dishIdComboDishIds: JSON.stringify([
            {
              dishId: this.editDish.id,
              comboDIshId: parseInt(this.editDish.pfandId)
            }
          ])
        },
        { showLoading: true }
      )

      this.editDish = null
      this.showEditPfand = false
      this.pfandModel.reload()
    },

    refresh () {
      location.reload()
    }

  }

}
</script>

<style scoped>

</style>
